import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  headerColumn: {
    width: '100%',

    selectors: {
      '& .ms-DetailsHeader-cellName': {
        display: 'flex',
        flexFlow: 'row',
        width: '100%',
        justifyContent: 'flex-end',
        height: pxToRem(32),
        paddingRight: pxToRem(10),
        paddingBottom: pxToRem(20),
        fontSize: pxToRem(12),
        fontWeight: 600,
      },
    },
  },
  root: {
    selectors: {
      '.ms-DetailsHeader': {
        backgroundColor: theme.palette.neutralLight,
        height: pxToRem(25),
        fontColor: theme.palette.neutralDark,
        borderBottom: 'none',
      },
      '.ms-DetailsRow': {
        borderBottom: 'none',
        color: theme.palette.neutralDark,
        backgroundColor: theme.palette.neutralLighterAlt,
      },
    },
  },
  firstCell: {
    paddingTop: `${pxToRem(8)} !important`,
    paddingBottom: `${pxToRem(8)} !important`,
  },
  otherCells: {
    paddingTop: `${pxToRem(18)} !important`,
    paddingBottom: `${pxToRem(18)} !important`,
  },
  oddRow: {
    selectors: {
      '.ms-DetailsRow-fields': {
        backgroundColor: theme.palette.neutralWhite,
      },
    },
  },
  rowData: {
    selectors: {
      '.ms-DetailsRow-cell': {
        paddingLeft: `${pxToRem(0)} !important`,
        paddingRight: pxToRem(10),
      },
    },
    float: 'right',
    fontWeight: 300,
    fontSize: pxToRem(16),
  },
  textStatement: {
    paddingLeft: pxToRem(24),
  },
  textDate: {
    fontWeight: 300,
    fontSize: pxToRem(10),
    paddingLeft: pxToRem(24),
  },
});
